import { i18nPlugin } from './i18n';
import { timePlugin } from './time';
import { formatPlugin } from './format';

const PLUGINS = [
    i18nPlugin,
    timePlugin,
    formatPlugin,
];

export const installPlugins = (vue) => PLUGINS.filter((plugin) => plugin).forEach(vue.use.bind(vue));
